import { useGetContractQueryData } from "@/hooks/useGetContractQueryData";
import { usePathname } from "next/navigation";
import { getFlow, getSubResourcePath } from ".";

export const useCountStepsProgress = () => {
  const pathname = usePathname();

  const state = useGetContractQueryData();

  const isNewContract = pathname.includes("/new/");
  let rank = 0;

  if (!state) {
    if (isNewContract) {
      //setting rank to 10 to show approx 10% progress as on page [id]/welcome
      return (rank = 10);
    }
    return null;
  }

  const flow = getFlow(state.contract, pathname);
  if (!flow) {
    return null;
  }

  const currentPathname = getSubResourcePath(pathname);

  rank = Object.keys(flow).findIndex(key => key === currentPathname) + 1;
  const count = Object.keys(flow).length;

  const pageNotFount = rank === -1;
  const isProgressHidden = pageNotFount;

  if (isProgressHidden) {
    return null;
  }

  return (rank * 100) / count;
};
